<template>
  <v-container class="mt-0">
    <v-layout row wrap justify-center class="mt-3">
      <v-flex xs12 class="text-xs-center mb-2">
        <h1>Trials By Indications</h1>
          <v-alert v-if="indications == false" color="info" icon="new_releases" :value="true">
            There are no indications.
          </v-alert>
      </v-flex>
      <v-flex xs10 sm11 md11 align-content-space-between mt-4 mb-0 ml-0 mr-0>
        <v-card class="info" v-for="(item) in indications" v-bind:key="item.indicationId"  :to="'/Trials/indications/' + item.indicationId">
          <v-list class="listItems">
              <v-list-tile class="pb-2 pt-2 pl-2">
                <v-list-tile-avatar>
                  <indication-icon left class="icon" />
                </v-list-tile-avatar>
                <v-list-tile-content class="pl-2">
                  <v-list-tile-title v-html="item.indicationName"></v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn light flat ripple>
                    <right-icon v-bind:color="item.active ? 'primary' : 'grey'" />
                  </v-btn>
                </v-list-tile-action>
                <!--
                <v-list-tile-action v-if="userIsAuthenticated" class="orange">
                  <template>
                    <app-edit-indication-dialog :indication="indication(index)"></app-edit-indication-dialog>
                  </template>                  
                </v-list-tile-action>
                <v-list-tile-action v-if="userIsAuthenticated" class="red darken-3">
                  <v-btn dark flat class="red darken-3 pa-2" @click="onDeleteIndication(item)">
                    <v-icon dark class="text--lighten-1">delete</v-icon>
                  </v-btn>
                </v-list-tile-action>
              -->
              </v-list-tile>
          </v-list>
        </v-card>
      </v-flex>
      <v-flex xs2 sm1 md1 ml-0 mr-0 mb-0 mt-4 justify-center v-if="userIsAuthenticated">
        <v-card class="info" v-for="(item2, index2) in indications" v-bind:key="item2.indicationId">
          <v-list class="listItems pa-0">
              <v-list-tile class="pa-2">
        				<app-edit-indication-dialog :indication="indication(index2)"></app-edit-indication-dialog>
              </v-list-tile>
          </v-list>          
        </v-card>      
      </v-flex>      
      <v-flex xs12 mb-4 v-if="userIsAuthenticated">
        <v-card class="info">
          <v-list class="listItems pa-0">
              <v-list-tile class="pa-2">
        				<app-create-indication-dialog></app-create-indication-dialog>
              </v-list-tile>
          </v-list>          
        </v-card>
      </v-flex>      
    </v-layout>
  </v-container>
</template>

<script>
export default {
  computed: {
    indications () {
      return this.$store.getters.loadedIndications
    },
    userIsAuthenticated () {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  methods: {
    indication (index) {
      console.log('CURRENT ITEM: ' + this.$store.getters.loadedIndication(this.indications[index].indicationId))
      return this.$store.getters.loadedIndication(this.indications[index].indicationId)
    },
    onDeleteIndication (indication) {
      console.log('Delete this: ' + JSON.stringify(indication))
      this.$store.dispatch('deleteIndicationData', indication)
      this.$router.push('/indications')
    }
  }
}
</script>



// WEBPACK FOOTER //
// Archive.vue?8b7f5e0a